import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/lib/locale/en';
import sv from 'vuetify/lib/locale/sv';

Vue.use(Vuetify);

function getLocale() {
  try {
    return window.localStorage.getItem('zoeziLanguage') || 'sv';
  } catch {
    return 'sv';
  }
}

export default new Vuetify({
  lang: {
    locales: {en, sv},
    current: getLocale()
  },
  breakpoint: {
    mobileBreakpoint: 'sm'
  }
});
